/* Contact form follow-up fields. Loaded by sections/contact-form.liquid.
   "I would like to" drives which `[data-for="Reason|Reason"]` rows show; the inputs in a hidden row are
   DISABLED so they are left out of the notification email. "Product or service" (store menu groups +
   a Custom services group) -> a collection option lists its products in the Product combobox
   (/collections/<handle>/products.json); otherwise typing queries /search/suggest.json, by name OR
   product code (variants.sku is in the searched fields). Suggestions read "<title> (<code>)", the code
   being the variant SKUs' common stem (34019L-2 -> 34019L). A recognised product fills the Size list
   from its variants ("<size> (<sku>)"; variants fetched from /products/<handle>.js when missing).
   Everything stays free-text: the lists only suggest. ?product=&sku=[&bulk=1|&sample=1], ?doc=, ?fresh=1,
   ?service= and ?reason= prefill; a request page's preset reason (section `default_reason`) is rendered
   `selected` by Liquid, so this script only overrides it when the URL says otherwise.
   With a Shopify Forms block ([data-contact-app]) none of this runs (the Forms app was retired 2026-09-20). */
(function () {
  'use strict';

  /* What the URL asks us to prefill: reason + product / size / service / body. */
  function plan() {
    var p = new URLSearchParams(window.location.search);
    var out = {};
    var qDoc = p.get('doc');
    if (qDoc) {  // gated resource document (no public file): ask for it via the document request
      out.body = 'Please send me: ' + qDoc;
      // Catalog & White Papers "Request" is a lead form of its own, not a CoA/SDS request (review 2026-09-16)
      // Catalog & White Papers "Request" is a comment on General Inquiry (no dedicated catalog reason)
      out.reason = p.get('kind') === 'whitepaper' ? 'General Inquiry' : 'Request CoA / Documentation';
    }
    if (p.get('service')) {  // Custom Services page: a service without its own page lands here as a custom quote
      out.reason = 'Custom Quote';
      out.service = p.get('service');
    }
    if (p.get('product')) {
      out.reason = p.get('bulk') === '1' ? 'Bulk Request' : p.get('sample') === '1' ? 'Request a Sample / Reserve Order' : 'Custom Quote';
      out.product = p.get('product');
      if (p.get('sku')) out.size = p.get('sku');
    }
    if (p.get('fresh') === '1') {  // a tissue page's "Contact us about fresh collection" (bulk request + fresh flag)
      out.body = (out.body ? out.body + '\n' : '') + 'Fresh collection request: please contact me about fresh collection of this tissue (quantity, frequency and needed-by date above).';
    }
    if (p.get('reason')) out.reason = p.get('reason');  // /pages/contact?reason=...
    return out;
  }

  // A Shopify Forms @app block swaps the native form out; nothing here applies to it.
  if (document.querySelector('[data-contact-app]')) return;

  var form = document.getElementById('ContactForm');
  if (!form) return;
  var reason = form.querySelector('[data-contact-reason]');
  var sub = form.querySelector('[data-contact-sub]');
  var rows = form.querySelectorAll('[data-for]');
  var category = form.querySelector('[data-contact-category]');
  var product = form.querySelector('[data-contact-product]');
  var size = form.querySelector('[data-contact-size]');
  var productList = document.getElementById('ContactForm-product-options');
  var sizeList = document.getElementById('ContactForm-size-options');
  if (!reason || !sub || !product) return;

  var byTitle = {};          // product title AND "title (code)" -> { title, handle, code, variants: [{ title, sku }] | null }
  var collectionCache = {};  // collection url -> Promise<product[]>

  function json(r) { return r.ok ? r.json() : Promise.reject(r.status); }
  function noop() {}

  function setOptions(list, values) {
    list.textContent = '';
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      list.appendChild(o);
    });
  }

  /* The product code shoppers know (label / catalog): the variant SKUs' stem before the size suffix. */
  function codeOf(variants) {
    var sku = ((variants || []).map(function (v) { return v.sku || ''; }).filter(Boolean)[0] || '').trim();
    return sku.replace(/-[^-]*$/, '');
  }

  function labelOf(p) { return p.code ? p.title + ' (' + p.code + ')' : p.title; }

  function pickOption(select, value) {
    if (!select) return false;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) { select.selectedIndex = i; return true; }
    }
    return false;
  }

  function toggle() {
    var want = reason.value, any = false;
    Array.prototype.forEach.call(rows, function (row) {
      var on = !!want && row.getAttribute('data-for').split('|').indexOf(want) !== -1;
      row.hidden = !on;
      any = any || on;
      Array.prototype.forEach.call(row.querySelectorAll('input, select, textarea'), function (el) { el.disabled = !on; });
    });
    sub.hidden = !any;
  }

  function variantsOf(p) {
    return (p.variants || []).map(function (v) { return { title: v.title, sku: v.sku }; });
  }

  function remember(items) {
    return items.filter(function (p) { return p && p.title; }).map(function (p) {
      var variants = p.variants ? variantsOf(p) : null;
      var entry = { title: p.title, handle: p.handle, code: codeOf(variants), variants: variants };
      byTitle[p.title] = entry;
      byTitle[labelOf(entry)] = entry;
      return entry;
    });
  }

  function fillSizes() {
    if (!size || !sizeList) return;
    var p = byTitle[product.value];
    if (!p) { setOptions(sizeList, []); return; }
    if (!p.variants) {
      fetch('/products/' + encodeURIComponent(p.handle) + '.js', { credentials: 'same-origin' })
        .then(json)
        .then(function (d) { p.variants = variantsOf(d); p.code = p.code || codeOf(p.variants); byTitle[labelOf(p)] = p; fillSizes(); })
        .catch(noop);
      return;
    }
    setOptions(sizeList, p.variants
      .filter(function (v) { return v.title && v.title !== 'Default Title'; })
      .map(function (v) { return v.title + (v.sku ? ' (' + v.sku + ')' : ''); }));
  }

  function loadCategory() {
    var opt = category.options[category.selectedIndex];
    var url = opt && opt.getAttribute('data-url');
    if (!url) { setOptions(productList, []); return; }  // a custom service, or no pick: the search fills the list instead
    if (!collectionCache[url]) {
      collectionCache[url] = fetch(url + '/products.json?limit=250', { credentials: 'same-origin' })
        .then(json)
        .then(function (d) { return remember(d.products || []); })
        .catch(function () { return []; });
    }
    collectionCache[url].then(function (items) {
      if (category.value !== opt.value) return;  // changed again meanwhile
      setOptions(productList, items.map(labelOf));
    });
  }

  var timer;
  function suggest() {
    fillSizes();
    var opt = category && category.options[category.selectedIndex];
    if (opt && opt.getAttribute('data-url')) return;  // the collection list is already the datalist
    var q = product.value.trim();
    if (q.length < 2) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      // variants.sku in the searched fields: typing a product code finds the product too
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10'
            + '&resources[options][fields]=title,product_type,variants.title,variants.sku', { credentials: 'same-origin' })
        .then(json)
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          setOptions(productList, remember(items).map(labelOf));
          fillSizes();
        })
        .catch(noop);
    }, 200);
  }

  function pickReason(value) { pickOption(reason, value); }

  var want = plan();
  if (want.body) {
    var body = document.getElementById('ContactForm-body');
    if (body) body.value = want.body;
  }
  if (want.service) pickOption(category, want.service);  // a custom service is an option of the Product or service menu
  if (want.reason) pickReason(want.reason);
  if (want.product) {
    product.value = want.product;
    if (size && want.size) size.value = want.size;
  }
  reason.addEventListener('change', toggle);
  if (category) category.addEventListener('change', loadCategory);
  product.addEventListener('input', suggest);
  product.addEventListener('change', fillSizes);
  toggle();
})();
